import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { CHART_ROLE_COLORS } from '@/theme/chartPalette';
import {
  CHART_LEGEND_STYLE,
  CHART_TOOLTIP_CONTENT_STYLE,
  CHART_TOOLTIP_ITEM_STYLE,
  CHART_TOOLTIP_LABEL_STYLE,
  DEFAULT_CHART_HEIGHT,
  buildValueFormatter,
} from './chartStyles';

export interface DonutSlice {
  key: string;
  label: string;
  value: number;
  color: string;
}

interface DonutChartProps {
  data: DonutSlice[];
  height?: number;
  accessibleLabel: string;
  formatValue: (value: number) => string;
}

export function DonutChart({
  data,
  height = DEFAULT_CHART_HEIGHT,
  accessibleLabel,
  formatValue,
}: DonutChartProps) {
  return (
    <div role="img" aria-label={accessibleLabel} className="w-full">
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="label"
            innerRadius="58%"
            outerRadius="82%"
            paddingAngle={2}
            stroke={CHART_ROLE_COLORS.surface}
            strokeWidth={2}
          >
            {data.map(function renderSlice(slice) {
              return <Cell key={slice.key} fill={slice.color} />;
            })}
          </Pie>
          <Tooltip
            formatter={buildValueFormatter(formatValue)}
            contentStyle={CHART_TOOLTIP_CONTENT_STYLE}
            labelStyle={CHART_TOOLTIP_LABEL_STYLE}
            itemStyle={CHART_TOOLTIP_ITEM_STYLE}
          />
          <Legend wrapperStyle={CHART_LEGEND_STYLE} iconType="circle" iconSize={9} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
